export default "__VITE_ASSET__Sib2TSTv__"